import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { LazyLoadImage } from 'react-lazy-load-image-component'
// MUI MATERIAL
import { Container, Typography, Box, Link as RouterLink, useTheme, useMediaQuery } from '@mui/material'
// CONSTANTS
import { neutralColor } from '../../constants/styling/colorPalette'

const link = [
    { title: "Beranda", url: "/" },
    { title: "Cari Mobil", url: "/cari-mobil-bekas-baru" },
    { title: "Harga Pasar", url: "/produk/djubli-market" },
    { title: "Gadai BPKB", url: "/produk/djubli-kredit/gadai-bpkb-mobil" },
    { title: "Kredit Kendaraan Bermotor", url: "/produk/djubli-kredit/kredit-kendaraan-bermotor" },
]

const PageNotFound = () => {

    const theme = useTheme()
    const downMediumScreen = useMediaQuery(theme.breakpoints.down("md"))
    const downLargeScreen = useMediaQuery(theme.breakpoints.down("lg"))

    return (
        <>
            {/* HEADER */}
            <Helmet>
                <title>
                    Halaman yang dicari tidak ditemukan | DjuBli platform jual beli mobil terpercaya.
                </title>
            </Helmet>

            <Container sx={{ padding: { xs: '1rem', sm: '1.5rem', md: '2rem'} }}>
                <Box 
                    minHeight={'60vh'}
                    display='flex' 
                    justifyContent='center' 
                    alignItems={downMediumScreen ? 'center' : 'center'}
                    py={3}
                    columnGap={6}
                    flexDirection={downMediumScreen ? 'column-reverse' : 'row'}
                >
                    <Box mt={downMediumScreen ? 4 : 0}>
                        <Typography
                            variant='h1'
                            fontWeight='bold'
                            component='h1'
                            color={neutralColor.neutral100}
                            align={downMediumScreen ? 'center' : 'left'}
                            style={{ fontSize: downMediumScreen ? '36px' : downLargeScreen ? "60px" : '96px' }}
                        >
                            Oops!
                        </Typography>

                        <Typography 
                            variant='h4'  
                            component='h2' 
                            align={'left'}
                            color={neutralColor.neutral90}
                            sx={{ marginTop: downLargeScreen ? "14px" : "10px" }}
                            style={{ fontSize: downMediumScreen ? '18px' : downLargeScreen ? "22px" : '34px' }}
                        >
                            Halaman yang kamu cari tidak ditemukan.
                        </Typography>

                        <Typography 
                            variant='h6'  
                            component='pre'
                            color={neutralColor.neutral80}
                            fontWeight='bold'
                            sx={{ marginTop: downLargeScreen ? "18px" : "12px" }}
                            style={{ fontSize: downMediumScreen ? '14px' : downLargeScreen ? "18px" : '20px' }}
                        >
                            Error Code: 404
                        </Typography>

                        <Typography 
                            variant='h6'  
                            component='pre'
                            color={neutralColor.neutral70}
                            sx={{ marginTop: downLargeScreen ? "12px" : "8px" }}
                            style={{ fontSize: downMediumScreen ? '16px' : '20px' }}
                        >
                            Mungkin kamu bisa lihat kesini:
                        </Typography>

                        <Box
                            display='flex'
                            flexDirection="column"
                            rowGap={"2px"}
                            mt={1}
                        >
                            {/* <Button 
                                variant='contained'
                                size='large'
                                sx={{ textTransform: 'capitalize' }}
                                onClick={() => { navigate('/') }}>
                                Ke Homepage
                            </Button> */}
                            
                            { link.map((link, index) => (
                                <RouterLink
                                    key={`not-found-link-${index + 1}`}
                                    to={link.url}
                                    underline="none"
                                    component={Link}
                                    color="primary"
                                    variant='body1'
                                >
                                    { link.title }
                                </RouterLink>
                            )) }
                        </Box>
                    </Box>

                    <Box display='flex' 
                        alignItems='center' 
                        justifyContent='center'
                        width={{ xs: '280px', sm:'400px'}}
                    >
                        <LazyLoadImage
                            src={`/images/not-found.png`}
                            alt={`Halaman tidak ditemukan by kapwing`}
                            loading="lazy"
                            width={downMediumScreen ? '280px' : '440px'}
                            height={downMediumScreen ? '159px' : '278px'}
                            effect="blur"
                        />
                    </Box>
                </Box>
            </Container>
        </>
    )
}

export default PageNotFound
